import {
  BANNER_ADD_REQUEST,
  BANNER_ADD_REQUEST_SUCCESS,
  BANNER_ADD_REQUEST_FAILURE,
  BANNER_FETCH_REQUEST,
  BANNER_FETCH_REQUEST_SUCCESS,
  BANNER_FETCH_REQUEST_FAILURE,
  BANNER_CLEAN_REQUEST,
  BANNER_TYPES_REQUEST,
  BANNER_TYPES_REQUEST_SUCCESS,
  BANNER_TYPES_REQUEST_FAILURE,
  BANNER_TYPES_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  CRUDErrors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

const TYPES_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const bannersReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case BANNER_FETCH_REQUEST:
    case BANNER_ADD_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case BANNER_FETCH_REQUEST_SUCCESS:
    case BANNER_ADD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case BANNER_FETCH_REQUEST_FAILURE:
    case BANNER_ADD_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case BANNER_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        CRUDErrors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export const bannerTypesReducer = (state, action) => {
  state = state || TYPES_INITIAL_STATE;

  switch (action.type) {
    case BANNER_TYPES_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case BANNER_TYPES_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case BANNER_TYPES_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case BANNER_TYPES_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default bannersReducer;
